const FREEMIUM_LIMITS = {
  searches_made: 200,
  emails_fetched: 50,
  emails_drafted: 30,
  emails_sent: 10,
};

const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:8000';
  }
  return 'https://ladder-6d6f.onrender.com';
};

const API_BASE_URL = getApiBaseUrl();

const isBrowser = typeof window !== 'undefined';
const IS_LOCALHOST = isBrowser
  ? window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  : false;

const SKIP_AUTH_FOR_DEV = IS_LOCALHOST;
const LOGO_URL = '/Ladder_Logo.png';

export { API_BASE_URL, FREEMIUM_LIMITS, IS_LOCALHOST, LOGO_URL, SKIP_AUTH_FOR_DEV };
